/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import GlobalSettings, { getRootUrl } from '@/model/global/GlobalSettings'

const entity = {
  image: {
    type: IKDataEntity.Types.Image,
    formConfig: {
      type: {
        root: () => getRootUrl() + GlobalSettings.bannerImageRoot
      },
      required: false
    },
    displayName: 'image'
  },
  sort: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      // required: true,
    }
  },
  target11: {
    displayName: 'Scale1_1',
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true,
      required: false
    },
    tableConfig: {
      width: '100px'
    }
  },
  target169: {
    displayName: 'Scale16_9',
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true,
      required: false
    },
    tableConfig: {
      width: '100px'
    }
  },
  target219: {
    displayName: 'Scale21_9',
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true,
      required: false
    },
    tableConfig: {
      width: '100px'
    }
  },
  target916: {
    displayName: 'Scale9_16',
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true,
      required: false
    },
    tableConfig: {
      width: '100px'
    }
  }
}
const config = {
  add: function (item) {
    item.target11 = item.target11 ? 1 : 0
    item.target169 = item.target169 ? 1 : 0
    item.target219 = item.target219 ? 1 : 0
    item.target916 = item.target916 ? 1 : 0
    return hillo.postWithUploadFile('Restaurant.php?op=uploadBannerV2', {
      ...item
    })
  },
  edit: function (item) {
    item.target11 = item.target11 ? 1 : 0
    item.target169 = item.target169 ? 1 : 0
    item.target219 = item.target219 ? 1 : 0
    item.target916 = item.target916 ? 1 : 0
    return hillo.postWithUploadFile('Restaurant.php?op=updateBannerV2', {
      ...item,
      params: JSON.stringify(item)
    })
  },
  remove: function (id) {
    return hillo.post('Restaurant.php?op=deleteBannerV2', { id })
  },
  load: async function () {
    return (await hillo.get('Restaurant.php?op=showBannerV2', {}))
      .content
  }
}

export default IKDataEntity.ModelFactory(entity, config)
